import {type ActionsObservable, ofType} from 'redux-observable';
import {from, Observable, of} from 'rxjs';
import {catchError, flatMap, map} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import GroupAPI from 'web-app/api/group-api';

import * as Api from './api';
import * as Actions from './actions';

const fetchGroupsObservable = institutionId =>
    Api.fetchAllGroups(institutionId).map(groups => Actions.fetchAllSuccess.action({groups, institutionId}));

const fetchAll = action$ =>
    action$
        .ofType(Actions.fetchAll.type)
        .mergeMap(({payload}) =>
            fetchGroupsObservable(payload.institutionId).catch(e => Observable.of(Actions.fetchAllFailed.action(e))),
        );

const createGroupObservable = (institutionId, title, suppressErrors = false) =>
    Api.createGroup(institutionId, title, suppressErrors).map(group => Actions.createSuccess.action(group));

const create = action$ =>
    action$
        .ofType(Actions.create.type)
        .mergeMap(({payload}) =>
            createGroupObservable(payload.institutionId, payload.title).catch(e =>
                Observable.of(Actions.fetchAllFailed.action(e)),
            ),
        );

const star = (action$: ActionsObservable<any>) =>
    action$.pipe(
        ofType(Actions.star.type),
        flatMap(({payload}) =>
            from(GroupAPI.star(payload.groupId)).pipe(
                map(() => Actions.starSuccess.action(payload.groupId)),
                catchError(() => of(Actions.starFailed.action(payload.groupId))),
            ),
        ),
    );

const unStar = (action$: ActionsObservable<any>) =>
    action$.pipe(
        ofType(Actions.unStar.type),
        flatMap(({payload}) =>
            from(GroupAPI.unStar(payload.groupId)).pipe(
                map(() => Actions.unStarSuccess.action(payload.groupId)),
                catchError(() => of(Actions.unStarFailed.action(payload.groupId))),
            ),
        ),
    );

export default combineEpics(fetchAll, create, star, unStar);
